import { ProductFeatures } from 'common/src/types/enums/ProductFeatures.enum';

import { IAuthorizationContext } from 'portal/src/auth/IAuthorizationContext';

export default function isSmartMeterViewEnabled(
  context: IAuthorizationContext,
): boolean {
  return context.featureChecker.productFeatureEnabled(
    ProductFeatures.smartMeters,
  );
}
